import * as cashBalanceActions from "../actions/cash-balances.actions"
import { CashBalancesViewType, CashBalancesModel } from "../models/cash-balances.model"
import { SubLedgerModel } from "../models/sub-ledger.model"
import { createEntityAdapter } from "@ngrx/entity"
import { EntityState } from "@ngrx/entity"
import { RuleSet, Rule } from "ngx-angular-query-builder"
import { CashBalanceFieldNames } from '../cash-balance-field-identifiers'


export class CashBalancesInstance {
  id: string;             // widget instance id
  groupByField1: string;
  groupByField2: string;
  selectedCurrency: string;
  view: CashBalancesViewType;
  loading: boolean;
  error: string;
  filter: RuleSet;
}

export const cashBalancesWidgetAdapter = createEntityAdapter<CashBalancesInstance>();

export interface CashBalancesState extends EntityState<CashBalancesInstance> {
  cashBalances: Array<CashBalancesModel>;
  subLedgers: Array<SubLedgerModel>;
}

export const INITIAL_STATE: CashBalancesState = cashBalancesWidgetAdapter.getInitialState({
  cashBalances: undefined,
  subLedgers: undefined
});

export function reducer(state: CashBalancesState = INITIAL_STATE, action: cashBalanceActions.Actions) {

  const getDefaultFilter = () => { return { condition: 'and', rules: [] } as RuleSet };

  switch (action.type) {
    case cashBalanceActions.LOAD:
      {

        if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
          return cashBalancesWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { loading: true } }, state);
        }

        return cashBalancesWidgetAdapter.addOne({
          id: action.widgetId.toString(),
          loading: true,
          error: null,
          groupByField1: CashBalanceFieldNames.SubLedgerField,
          groupByField2: CashBalanceFieldNames.TypeField,
          selectedCurrency: null,
          view: 'cashBalanceTable',
          filter: getDefaultFilter()
        }, state);

      }
    case cashBalanceActions.LOAD_COMPLETE:
      {
        state.cashBalances = action.payload;
        if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
          return cashBalancesWidgetAdapter.updateOne({
            id: action.widgetId.toString(), changes: {
              id: action.widgetId.toString(),
              loading: false,
              filter: getDefaultFilter()
            }
          }, state);
        }
        return cashBalancesWidgetAdapter.addOne({
          id: action.widgetId.toString(),
          loading: false,
          error: null,
          groupByField1: CashBalanceFieldNames.SubLedgerField,
          groupByField2: CashBalanceFieldNames.TypeField,
          selectedCurrency: null,
          view: 'cashBalanceTable',
          filter: getDefaultFilter()
        }, state);

      }
    case cashBalanceActions.LOAD_ERROR:
      {
        let errorMessage = null;
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }
        if (typeof state.ids[action.widgetId] === 'undefined') {
          return cashBalancesWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { error: errorMessage } }, state);
        }
        return state;
      }
    case cashBalanceActions.LOAD_CONFIGURATION:
      {

        if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
          return cashBalancesWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { loading: true } }, state);
        }

        return cashBalancesWidgetAdapter.addOne({
          id: action.widgetId.toString(),
          loading: true,
          error: null,
          groupByField1: CashBalanceFieldNames.SubLedgerField,
          groupByField2: CashBalanceFieldNames.TypeField,
          selectedCurrency: null,
          view: 'cashBalanceTable',
          filter: getDefaultFilter()
        }, state);

      }
    case cashBalanceActions.LOAD_CONFIGURATION_COMPLETE:
      {
        if (action.payload != null) {
          if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
            return cashBalancesWidgetAdapter.updateOne({
              id: action.widgetId.toString(),
              changes: {
                id: action.widgetId.toString(),
                loading: false,
                groupByField1: action.payload.GroupByField1,
                groupByField2: action.payload.GroupByField2,
                view: action.payload.View
              }
            },
              state);
          }
          return cashBalancesWidgetAdapter.addOne({
            id: action.widgetId.toString(),
            loading: false,
            error: null,
            groupByField1: action.payload.GroupByField1,
            groupByField2: action.payload.GroupByField2,
            selectedCurrency: null,
            view: action.payload.View,
            filter: getDefaultFilter()
          },
            state);
        }
        else {
          return {
            ...state
          }
        }
      }
    case cashBalanceActions.LOAD_CONFIGURATION_ERROR:
      {
        let errorMessage = null;
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }
        if (typeof state.ids[action.widgetId] === 'undefined') {
          return cashBalancesWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { error: errorMessage } }, state);
        }
        return {
          ...state
        }
      }
    case cashBalanceActions.UPDATE_GROUPING:
      {
        if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
          return cashBalancesWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { id: action.widgetId.toString(), groupByField1: action.groupByField1, groupByField2: action.groupByField2, selectedCurrency: action.currency } }, state);
        }
        return cashBalancesWidgetAdapter.addOne({
          id: action.widgetId.toString(), loading: false, error: null, groupByField1: action.groupByField1, groupByField2: action.groupByField2,
          view: 'cashBalanceTable',
          filter: getDefaultFilter(),
          selectedCurrency: action.currency,
        }, state);
      }
    case cashBalanceActions.UPDATE_VIEW:
      {
        if ((<Array<string>>state.ids).indexOf(action.widgetId) !== -1) {
          return cashBalancesWidgetAdapter.updateOne({ id: action.widgetId.toString(), changes: { id: action.widgetId.toString(), view: action.view } }, state);
        }
        return cashBalancesWidgetAdapter.addOne({
          id: action.widgetId.toString(),
          loading: false,
          error: null,
          groupByField1: CashBalanceFieldNames.SubLedgerField,
          groupByField2: CashBalanceFieldNames.TypeField,
          selectedCurrency: null,
          view: 'cashBalanceTable',
          filter: getDefaultFilter()
        }, state);
      }
    case cashBalanceActions.LOAD_SUB_LEDGERS_COMPLETE:
      {
        return {
          ...state,
          subLedgers: action.payload
        }
      }
    default:
      {
        return state;
      }
  }
}
